export default __webpack_public_path__ + "static/media/CEO1.5624eae6.jpg";